import type { PageContext } from "vike/types";
import { TOMORROW_SLUG, tomorrowNames } from "@/data/tomorrow-co";
import type { CollectionData } from "./+data";

export function title(pageContext: PageContext): string {
  const data = pageContext.data as CollectionData | undefined;
  if (!data) return "OddStack Shop";
  if (data.collection.slug === TOMORROW_SLUG) return tomorrowNames(data.collection.name).title;
  return `${data.collection.name} — OddStack Shop`;
}
